export const lightTheme = {
  background: "#ffffff",

  text: "#000000",
  text2: "#222",
  text3: "#fff",

  muted: "#6b7280",
  muted2: "#F0f0f0",

  hover: "#F0f0f0",
  hoverText: "#fff",

  primary: "#222",
  primary2: "#1e1e1e",
  primary3: "#222",
  primary4: "#222",

  card: "#fff",
  card2: "#fff",
  card3: "#fff",

  border: "#e5e7eb",

  footerTheme: {
    background: "#0d0f14",
    text: "#f2f4f7",
    muted: "#c6cbd2",
    border: "#1f2937",
    accent: "#9aa4b2",
  },

  color0: "#fff",
  color1: "#D1D2D3",
  color2: "#434344",
  color3: "#222",
  color4: "#1f1b1c",
  color5: "#1f1b1c",

  error: "#cf6161ff",

  btn: "#1e1e1e",

  status: "#0000009b",
  dot: "#000",
  surface: "#1a1a1a",
};

export const darkTheme = {
  background: "#1e1e1e",

  text: "#fff",
  text2: "#fff",
  text3: "#fff",

  muted: "#9ca3af",
  muted2: "#c1c1c1ff",

  hover: "#474747",
  hoverText: "#fff",

  primary: "#474747ff",
  primary2: "#474747ff",
  primary3: "#000000",
  primary4: "#bcbcbc",

  card: "#434344",
  card2: "#262626ff",
  card3: "#1e1e1e",

  border: "#3a3a3a",

  footerTheme: {
    background: "#0d0f14",
    text: "#f2f4f7",
    muted: "#c6cbd2",
    border: "#1f2937",
    accent: "#9aa4b2",
  },

  color0: "#1e1e1e",
  color1: "#434344",
  color2: "#D1D2D3",
  color3: "#222",
  color4: "#fff",
  color5: "#1f1b1c",

  error: "#db4343ff",

  btn: "#fff",

  status: "#B7B7B7D6",
  dot: "#676767",

  surface: "#1a1a1a",
};
